import * as React from "react";

export const XCircleIcon = (): React.ReactElement => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g id="XCircle">
            <path
                id="Vector"
                d="M12 21.00C16.97 21.00 21 16.97 21 12.00C21 7.03 16.97 3.00 12 3.00C7.03 3.00 3 7.03 3 12.00C3 16.97 7.03 21.00 12 21.00Z"
                fill="#D7D7D7"
            />
            <path
                id="Vector_2"
                d="M15 9.00L9 15.00"
                stroke="#393939"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                id="Vector_3"
                d="M15 15.00L9 9.00"
                stroke="#393939"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </g>
    </svg>
);
